import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import React from 'react';
import {
  Wrapper,
  ButtonCancel,
  ButtonClear
} from './styled';

interface Props {
  handleClickCancel?: Function;
  handleClickDelete?: Function;
  actionText?: string;
}

export const ActionsForAll: React.FC<Props> = ({ handleClickCancel, handleClickDelete, actionText }) => (
  <Wrapper>
    <ButtonCancel onClick={handleClickCancel}>
      <Icon data-name="icon-close-bold" fill={COLORS.BLACK_BOLD} height="14" width="14" />
      Cancelar
    </ButtonCancel>
    <ButtonClear onClick={handleClickDelete}>
      {actionText}
    </ButtonClear>
  </Wrapper>
);